// extracted by mini-css-extract-plugin
module.exports = {"sections":"App_sections__RTq54","installBanner":"App_installBanner__2HvyS"};